import React, {Fragment} from "react";
import PropTypes from "prop-types";
import SpinnerDiv from "root/Components/SpinnerDiv";
import PassportTable, {xlateBootstrapTableColumns} from "root/Tables/PassportTable";

import {
    defaultTableHeaderStyles,
    defaultPaginationOptions,
    customHeaderStyle, defaultTopLeftCellStyle, defaultTopRightCellStyle,
    TableActionIconDelete, TableActionIconEdit, TableActionIconView
} from "./BaseTableComponents";

import './Table.scss'

const FamilyMemberTable = (props) =>
{
    const onClickItem = (family_member_id, mode) =>
    {
        props.clickHandler(family_member_id, mode, props.onDialogClosed);
    }

    const linkFormatter = (cell, row, rowIndex, formatExtraData) =>
    {
        return (
            <Fragment>
                <TableActionIconDelete text="Delete Family Member" onClick={() => onClickItem(row.ar_id, 'delete')} />
                <TableActionIconEdit text="Edit Details" onClick={() => onClickItem(row.ar_id, 'edit')} />
                <TableActionIconView text="View Details" onClick={() => onClickItem(row.ar_id, 'view')} />
            </Fragment>
        );
    }

    const leftHeaderStyle = customHeaderStyle.bind(null, {
        default: defaultTableHeaderStyles,
        firstname: {borderRadius: defaultTopLeftCellStyle, width: "12vw"},
        surname: {width: "10vw"},
        name: {width: "10vw"},
        view: {borderRadius: defaultTopRightCellStyle, textAlign: 'right', width: "6vw"}
    });

    const getColumns = () => {
        const columns = [
            {
                dataField: "firstname",
                text: "Name",
                sort: true,
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "surname",
                text: "Family Name",
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "name",
                text: "Relation",
                headerStyle: leftHeaderStyle
            },
            {
                dataField: "view",
                formatter: linkFormatter,
                align: 'right',
                text: "Manage",
                headerStyle: leftHeaderStyle
            },
        ];

        return columns;
    };

    const translations = xlateBootstrapTableColumns(getColumns());
    const columns = React.useMemo(() => translations, []);

    const thisTableContent = () =>
    {
        return <PassportTable data={props.data} columns={columns} pagination={defaultPaginationOptions}/>
    }

    return props.loading === true ? <SpinnerDiv/> : thisTableContent();
    };

export default FamilyMemberTable;

FamilyMemberTable.propTypes = {
    family_id: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool
};